(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_76f480c"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("multilingual-scrolling-ticker")) {
    class MultilingualScrollingTicker extends HTMLElement {
      connectedCallback() {
        if (this.dataset.speedEnabled !== "true") return;
        this.track = this.firstElementChild;
        this.group = this.track.firstElementChild;
        this.updateSpeed = this.updateSpeed.bind(this);
        this.observer = new ResizeObserver(this.updateSpeed);
        this.observer.observe(this.group);
        this.updateSpeed();
        document.fonts.ready.then(() => {
          if (this.isConnected) this.updateSpeed();
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      updateSpeed() {
        const width = this.group.getBoundingClientRect().width;
        const percent = Number(this.dataset.speedPercent) || 100;
        const duration = width / (98.35489222007915 * percent / 100);
        if (!width || Math.abs(duration - this.duration) < 0.000001) return;
        const animation = this.track.getAnimations()[0];
        const oldDuration = parseFloat(getComputedStyle(this.track).animationDuration) * 1000;
        const currentTime = animation?.currentTime;
        const phase = typeof currentTime === "number" && oldDuration > 0
          ? (currentTime % oldDuration) / oldDuration : 0;
        this.track.style.animationDuration = duration + "s";
        const updatedAnimation = this.track.getAnimations()[0];
        if (updatedAnimation) updatedAnimation.currentTime = phase * duration * 1000;
        this.duration = duration;
      }
    }
    customElements.define("multilingual-scrolling-ticker", MultilingualScrollingTicker);
  }
  } catch(e) { console.error(e); }
})();

})();
